import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import { View } from 'react-native';
import { Badge, Callout, getTestId, isValidObject, StateConfigContext } from '@airtel/air-design-system';
import { getChipsGroupWidgetStyles } from './ChipsGroupWidgetStyles';
import { isLastChip, isLastRow } from './ChipsGroupWidgetUtils';
import { ButtonWidgetComponent } from '../../../../../button-widget/ButtonWidget';
import { withBoundaries } from '../../../../../../hoc';
var ChipsGroupWidgetComponent = props => {
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var id = props.id,
    _props$chipsList = props.chipsList,
    chipsList = _props$chipsList === void 0 ? [] : _props$chipsList,
    onUserAction = props.onUserAction,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'ChipsGroupWidget' : _props$testID,
    _props$numOfColumns = props.numOfColumns,
    numOfColumns = _props$numOfColumns === void 0 ? 2 : _props$numOfColumns,
    buttonWidgetData = props.buttonWidgetData,
    onChipPressMetaData = props.onChipPressMetaData,
    _props$selectedChipIn = props.selectedChipIndex,
    _selectedChipIndex = _props$selectedChipIn === void 0 ? 0 : _props$selectedChipIn,
    calloutProps = props.calloutProps;
  var chipsGroupWidgetStyles = getChipsGroupWidgetStyles(props);
  var _useState = useState([]),
    chipsListState = _useState[0],
    setChipsListState = _useState[1];
  var _useState2 = useState(_selectedChipIndex),
    selectedChipIndex = _useState2[0],
    setSelectedChipIndex = _useState2[1];
  useEffect(() => {
    setChipsListState(chipsList);
  }, [JSON.stringify(chipsList)]);
  useEffect(() => {
    setSelectedChipIndex(selectedChipIndex);
    setChipsListState(prev => prev.map((chip, i) => Object.assign(Object.assign({}, chip), {
      isSelected: i === _selectedChipIndex
    })));
  }, [_selectedChipIndex]);
  var onChipPressHandler = chipIndex => {
    setChipsListState(prev => prev.map((chip, i) => Object.assign(Object.assign({}, chip), {
      isSelected: i === chipIndex
    })));
    setSelectedChipIndex(chipIndex);
    isValidObject(onChipPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onChipPressMetaData), Object.assign(Object.assign({}, chipsListState[chipIndex]), {
      isSelected: true,
      index: chipIndex
    })));
  };
  return _jsxs(View, Object.assign({}, getTestId(testID, 'mainView'), {
    style: chipsGroupWidgetStyles.mainContainer
  }, {
    children: [calloutProps && _jsx(Callout, Object.assign({}, calloutProps, getTestId(testID, 'callout'), {
      style: chipsGroupWidgetStyles.calloutContainer
    })), _jsx(View, Object.assign({}, getTestId(testID, 'chipsContainer'), {
      style: chipsGroupWidgetStyles.chipsContainer
    }, {
      children: chipsListState.map((chipProps, index) => {
        return _jsx(View, Object.assign({
          style: [chipsGroupWidgetStyles.chip, isLastChip(index, numOfColumns) && chipsGroupWidgetStyles.lastChip, isLastRow(index, numOfColumns, chipsListState.length) && chipsGroupWidgetStyles.lastRow]
        }, {
          children: _jsx(Badge, Object.assign({}, chipProps, {
            style: chipsGroupWidgetStyles.badge,
            onPress: () => onChipPressHandler(index),
            theme: theme
          }))
        }), index);
      })
    })), buttonWidgetData && _jsx(ButtonWidgetComponent, Object.assign({
      onUserAction: onUserAction
    }, buttonWidgetData, {
      style: chipsGroupWidgetStyles.buttonContainer
    }))]
  }));
};
ChipsGroupWidgetComponent.genericRendererKey = 'AirChipsGroupWidget';
export var ChipsGroupWidget = withBoundaries(ChipsGroupWidgetComponent);